
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10","cy":"10","r":"9.5","fill":"#fff","stroke":"#fff"}}),_c('g',{attrs:{"stroke":"#333","stroke-width":"1.5","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M10 4v11.997M16 10l-12 .002"}})])])
          )
        }
      }
    